var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcatChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 58,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#233851",
    d: "M6.641 37.23c12.469-1.912 19.606-8.695 21.553-20.68 1.136 5.233 2.814 10.108 6.809 13.958 4.058 3.91 9.116 5.709 14.876 6.665-12.478 1.916-19.724 8.655-21.617 20.81-2.006-11.95-9.016-18.916-21.625-20.75l.004-.004ZM27.692 14.657c-7.666 1.457-12.211 5.671-13.617 13.28C12.443 20.518 8.11 15.904 0 14.858 7.033 11.988 11.755 7.336 14.164.903c1.246 7.955 5.838 12.303 13.528 13.754Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#233851",
    d: "M42.775 9.62c1.379 5.972 4.405 9.425 9.994 10.496-5.475 1.316-8.65 4.55-9.94 10.596C41.51 24.653 38.314 21.399 32 20.195c6.221-1.296 9.55-4.424 10.775-10.582v.007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcatChatIcon);
export default __webpack_public_path__ + "static/media/mcat-chat-icon.887d7e23f90c68264ef6dcdeb5c8caef.svg";
export { ForwardRef as ReactComponent };